import { vars } from '@etg/wings';
import { useDirection } from '@eti/providers';
import { css, cx } from '@eti/styles';
import { CaretLeft, CaretRight } from '@phosphor-icons/react';
import type { NextMonthButtonProps, PreviousMonthButtonProps } from 'react-day-picker';

const buttonStyles = css`
  /* stylelint-disable custom-property-pattern */
  --rdp-nav_button-height: 2.75rem;
  --rdp-nav_button-width: 2.75rem;
  /* stylelint-enable custom-property-pattern */

  -webkit-tap-highlight-color: transparent;

  &:focus-visible {
    outline: 0.125rem solid ${vars.colors.focusRing};
  }

  &[aria-disabled='true']&:focus-visible {
    cursor: not-allowed;
    outline: none;
  }
`;

const getCaretStyles = (isRTL: boolean) => css`
  height: 1.25rem;
  transform: rotate(${isRTL ? '180deg' : '0deg'});
  width: 1.25rem;
`;

interface ChangeMonthButtonProps extends NextMonthButtonProps, PreviousMonthButtonProps {
  direction: 'next' | 'previous';
}

const ChangeMonthButton = ({ className, direction, ...rest }: ChangeMonthButtonProps) => {
  const { isRTL } = useDirection();
  const Caret = direction === 'next' ? CaretRight : CaretLeft;

  return (
    <button
      className={cx(
        className,
        buttonStyles,
        direction === 'previous' ? 'rdp-button_previous-month' : 'rdp-button_next-month',
      )}
      data-month-button={direction === 'previous' ? 'previous' : 'next'}
      type="button"
      {...rest}
    >
      <Caret aria-hidden className={getCaretStyles(isRTL)} weight="bold" />
    </button>
  );
};

export default ChangeMonthButton;
